import { render, staticRenderFns } from "./OrderManagementDialog.vue?vue&type=template&id=2ab9e106&scoped=true"
import script from "./OrderManagementDialog.vue?vue&type=script&lang=js"
export * from "./OrderManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderManagementDialog.vue?vue&type=style&index=0&id=2ab9e106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9e106",
  null
  
)

export default component.exports